module.exports = __webpack_public_path__ + "img/18.36db8a97.jpg";